// NOTE: DON'T CHANGE THE ORDER OF THESE IMPORT STATEMENTS
import router from "./router";
import store from "./store";
import "@/firebase/";
import { createApp } from "vue";
import "./registerServiceWorker";
import "tailwindcss/tailwind.css";
import Toaster from "@meforma/vue-toaster";
import App from "./App.vue";

createApp(App).use(store).use(router).use(Toaster).mount("#app");


window.addEventListener('beforeinstallprompt', (e) => {
    console.log(`'beforeinstallprompt' event was fired.`);
    e.preventDefault();
});